import React from "react";

interface InputLabelProps {
  children: React.ReactNode;
}

function InputLabel({ children }: InputLabelProps) {
  return (
    <label
      className=" text-nowrap"
      style={{
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        maxWidth: "100%",
        overflow: "hidden",
        marginBottom: -5,
        // marginLeft: 5,
        color: "rgb(var(--color-blue))",
        fontWeight: "bold",
      }}
    >
      {children}
    </label>
  );
}

export default InputLabel;
